import type { InterventionTaskViewModel } from '@generated';
import React from 'react';
import { SectionCard } from '~/shared/section/SectionCard';
import { LocatorItemSectionCheckboxes } from './LocatorItemSectionCheckboxes';

export function Prognosis({ interventionTask }: { interventionTask: InterventionTaskViewModel }) {
	const value = interventionTask.values?.['170967006'];
	const selectedOption = interventionTask?.interventionDefinition?.documentationFormControls[0].options?.find(x => x.value === value);
	return <SectionCard title="Prognosis" value={selectedOption ? selectedOption.label : '-'} />;
}

export function RehabPotential({ interventionTask }: { interventionTask: InterventionTaskViewModel }) {
	const value = interventionTask.values?.['rehabPotential'];
	const selectedOption = interventionTask?.interventionDefinition?.documentationFormControls[0].options?.find(x => x.value === value);
	return <SectionCard title="Rehab Potential" value={selectedOption ? selectedOption.label : '-'} />;
}

export function MentalStatus({ interventionTask }: { interventionTask: InterventionTaskViewModel }) {
	const values = interventionTask.values?.['mentalStatus'].split(',') as string[] | undefined;
	const selectedOptions = interventionTask?.interventionDefinition?.documentationFormControls[0].options?.filter(x => values?.includes(x.value));
	return (
		<SectionCard title="Mental Status">
			<LocatorItemSectionCheckboxes items={selectedOptions?.map(x => ({ label: x.label })) || []} />
		</SectionCard>
	);
}

export function ActivitiesPermitted({ interventionTask }: { interventionTask: InterventionTaskViewModel }) {
	const values = interventionTask.values?.['activitiesPermitted_findings'].split(',') as string[] | undefined;
	const selectedOptions = interventionTask?.interventionDefinition?.documentationFormControls[0].options?.filter(x => values?.includes(x.value));
	return (
		<SectionCard title="Activities Permitted">
			<LocatorItemSectionCheckboxes items={selectedOptions?.map(x => ({ label: x.label })) || []} />
		</SectionCard>
	);
}

export function FunctionalLimitations({ interventionTask }: { interventionTask: InterventionTaskViewModel }) {
	const values = interventionTask.values?.['functionalLimitations'].split(',') as string[] | undefined;
	const selectedOptions = interventionTask?.interventionDefinition?.documentationFormControls[0].options?.filter(x => values?.includes(x.value));
	return (
		<SectionCard title="Functional Limitations">
			<LocatorItemSectionCheckboxes items={selectedOptions?.map(x => ({ label: x.label })) || []} />
		</SectionCard>
	);
}

export function NutritionalRequirements({ interventionTask }: { interventionTask: InterventionTaskViewModel }) {
	const values = interventionTask.values?.['nutritionalRequirements'].split(',') as string[] | undefined;
	const selectedOptions = interventionTask?.interventionDefinition?.documentationFormControls[0].options?.filter(x => values?.includes(x.value));
	return (
		<SectionCard title="Nutritional Requirements">
			<LocatorItemSectionCheckboxes items={selectedOptions?.map(x => ({ label: x.label })) || []} />
		</SectionCard>
	);
}

export function SafetyMeasures({ interventionTask }: { interventionTask: InterventionTaskViewModel }) {
	const values = interventionTask.values?.['safetyMeasures'].split(',') as string[] | undefined;
	const selectedOptions = interventionTask?.interventionDefinition?.documentationFormControls[0].options?.filter(x => values?.includes(x.value));
	return (
		<SectionCard title="Safety Measures">
			<LocatorItemSectionCheckboxes items={selectedOptions?.map(x => ({ label: x.label })) || []} />
		</SectionCard>
	);
}
